import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';

export class GetComponentHistoryById {
  static readonly type = '[Component History] Get Component History';
  constructor(
    public componentId: string,
    public filter?: MainTableFilterModel
  ) {}
}
